let ignoreOutsideClickUntil = 0
const IGNORE_WINDOW_MS = 100

export const markDropdownOutsideInteraction = () => {
    ignoreOutsideClickUntil = Date.now() + IGNORE_WINDOW_MS
}

export const shouldIgnoreDropdownOutsideInteraction = () => {
    return Date.now() < ignoreOutsideClickUntil
}

export const isDropdownMenuOpen = () => {
    if (typeof document === 'undefined') {
        return false
    }

    return !!document.querySelector(
        '[data-radix-menu-content][data-state="open"], [data-radix-dropdown-menu-content][data-state="open"]'
    )
}
